// extracted by mini-css-extract-plugin
export default {"textContainer":"_186348af","svgIcon":"_2d31fb3c"};